import { Link } from "react-router-dom";
import { brandLogoWide } from "../../../../utils";

const HeaderLayout1 = ({ admissionImg }) => {
  return (
    <div className="d-flex justify-content-between align-items-center">
      <div className="text-start">
        <Link to="/" className="logo-link">
          <img
            src={brandLogoWide()}
            alt="Logo"
            className="img-fluid"
            style={{
              width: "100%",
              maxWidth: admissionImg > 0 ? admissionImg + "px" : "100%",
            }}
          />
        </Link>
      </div>

      <div className="d-flex align-items-center gap-4">
        <Link
          to="/sign-in"
          className="text-decoration-none text-dark fw-bold fs-13 d-flex align-items-center hover-opacity"
        >
          <i className="fa-solid fa-right-to-bracket me-2 text-secondary-theme"></i>
          SIGN IN
        </Link>
        <Link
          to="/sign-up"
          className="btn-secondary-theme-solid px-4 py-2 fs-12 fw-800 text-decoration-none shadow-sm"
        >
          <i className="fa-solid fa-user-plus me-2"></i>
          REGISTER NOW
        </Link>
      </div>
    </div>
  );
};

export default HeaderLayout1;
